<template>
  <sui-page>
    <sui-page-header title="LOGIN"></sui-page-header>
    <sui-page-contents>
      <div class="sso-wrapper">
        <section class="sso-header">
          <p class="txt">SEHS Package</p>
        </section>
        <section class="sso-body">
          <fieldset class="id-pw">
            <legend>ID / Password</legend>
            <form id="loginForm" action="" role="form" method="POST">
                <label for="id" class="blind">ID</label><input type="text" id="userId" name="userId" class="space01" placeholder="email">
                <label for="password" class="blind">Password</label><input type="password" id="password" name="password" placeholder="Password">
                <div style="display:inline-flex;width:100%">
                  <button type="button" id="signInBtn" class="bt-st01"><span>Sign In</span></button>
                  <button type="button" id="signInBtn" class="bt-st02"><span>Sign Up</span></button>
                </div>
            </form>
        </fieldset>
        </section>
        <section class="sso-footer">
          <span class="info">Forgot your password?<a href="#" class="link01">Click Here!</a></span>
        </section>
    </div>
    </sui-page-contents>
  </sui-page>
</template>

<script>
export default {
  name: 'Template03', // eslint-disable-line vue/name-property-casing
  data() {
    return {
      // Codes

    };
  },
  computed: {},
  watch: {},
  datasets: [],
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {},
};
</script>

<style scoped>
.sso-wrapper .sso-header { background:#536dc2; height:250px; padding-top:80px;box-sizing:border-box;  text-align:center; }
.sso-wrapper .sso-header .txt {font-size:25px; line-height:30px; color:#fff; margin-top:15px; letter-spacing:0}
.sso-wrapper .sso-body { max-width:375px;  padding:0 20px; margin:50px auto 0 auto;}
.sso-wrapper .sso-footer {max-width:375px; margin:30px auto 0 auto; padding:0 20px;text-align: center;}
.sso-body .id-pw input { border:1px solid #bbb; width:100%; height:46px; padding:0 10px; line-height:46px; font-size:15px;  }
.sso-body .bt-st01 { width:100%; margin-top:20px}
.sso-body .bt-st02 { width:100%; margin-top:20px;margin-left:20px}
.sso-footer .link01 { vertical-align:middle; display:inline-block; margin-top:-4px;margin-left:10px}
.space01 { margin-bottom:10px;}
/* text button */
.bt-st01 {display:inline-block;  background:#2949b3; white-space:nowrap; color:#fff; vertical-align:middle;  height:50px; text-align:center; font-size:18px; }
.bt-st01:hover {background:#626466; color:#fff;}
.bt-st02 {display:inline-block;  background:#959595; white-space:nowrap; color:#fff; vertical-align:middle; height:50px; text-align:center; font-size:18px; }
.bt-st02:hover {background:#626466; color:#fff;}
.info {font-size:14px; color:#333;line-height:30px;}
.link01 { font-size:14px; color:#188fe0; text-decoration:underline}
.link01:hover { color:#0059ab; }
</style>
